// import ReactGA from 'react-ga4';
import { v4 as uuidV4 } from 'uuid';
import {
  AUTOKEY_GA_CLIENT_ID,
  AUTOKEY_GA_SESSION_ID,
  getItemLocalStorage,
  setItemLocalStorage,
} from '../utils/helper';

export const setUtmParams = (params) => {
  sessionStorage.setItem('utmParams', JSON.stringify(params));
};

let clientId = getItemLocalStorage(AUTOKEY_GA_CLIENT_ID);
if (!clientId) {
  clientId = uuidV4();
  setItemLocalStorage(AUTOKEY_GA_CLIENT_ID, clientId);
}

let sessionId = sessionStorage.getItem(AUTOKEY_GA_SESSION_ID);
if (!sessionId) {
  sessionId = uuidV4();
  sessionStorage.setItem(AUTOKEY_GA_SESSION_ID, sessionId);
}

/**
 * Initializes Google Analytics with the provided analytics key.
 * @param {string} analyticsKey - The Google Analytics Measurement ID.
 */
export const initializeAnalytics = (analyticsKey) => {
  if (analyticsKey) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsKey}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = window.gtag || gtag;

    window.gtag('js', new Date());

    window.gtag('config', analyticsKey, {
      linker: {
        domains: ['auto.product.integrations.habit.io'],
      },
      client_storage: 'none',
      client_id: clientId,
      user_id: sessionId,
    });
  } else {
    console.warn('Google Analytics Key is not provided.');
  }
};

/**
 * Logs a custom event to Google Analytics.
 * @param {string} action - The type of interaction (e.g., 'submit_stage').
 * @param {object} params - Additional parameters for the event.
 */
export const logEvent = async (action, params = {}) => {
  const storedUtmParams = sessionStorage.getItem('utmParams');
  const utmParams = storedUtmParams ? await JSON.parse(storedUtmParams) : {};

  const isInIframe = window.self !== window.top;
  if (window.gtag) {
    const eventParams = {
      ...utmParams,
      ...params,
      sessionID: sessionId,
      transport_type: 'beacon',
    };
    window.gtag('event', action, eventParams);

    if (isInIframe)
      window.parent.postMessage(
        { type: 'customEvent', action, eventParams },
        '*'
      );
  } else {
    console.warn('gtag is not available yet.');
  }
};

/**
 * Logs a pageview to Google Analytics.
 * @param {string} path - The path of the page being viewed.
 */
export const logPageView = (path) => {
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path,
      sessionID: sessionId,
      transport_type: 'beacon',
    });
  } else {
    console.warn('gtag is not available yet.');
  }
};

export const events = {
  subimitBioForm: () =>
    logEvent('submit_bio_form', {
      event_category: 'Button',
      event_label: 'begin_simulation',
      value: 1,
    }),
  openHabitTag: () =>
    logEvent('open_habit_tag', {
      event_category: 'Click',
      event_label: 'open_habit_tag',
      value: 1,
    }),
  submitDriverForm: () =>
    logEvent('submit_driver_form', {
      event_category: 'Button',
      event_label: 'submit_driver_data',
      value: 1,
    }),
  submitOldRegistrations: () =>
    logEvent('submit_old_registrations', {
      event_category: 'Button',
      event_label: 'submit_old_registrations',
      value: 1,
    }),

  changeInsuranceProduct: (productName) =>
    logEvent('change_insurance_product', {
      event_category: 'Click',
      event_label: 'change_insurance_product',
      product_name: productName,
    }),

  getNewProductRateBase: () =>
    logEvent('get_new_product_rate_base', {
      event_category: 'Click',
      event_label: 'get_new_product_rate_base',
      value: 1,
    }),

  submitSimulationForm: () =>
    logEvent('submit_simulation_form', {
      event_category: 'Button',
      event_label: 'submit_simulation_form',
      value: 1,
    }),

  sendSimulationEmail: () =>
    logEvent('send_simulation_email', {
      event_category: 'Button',
      event_label: 'send_simulation_email',
      value: 1,
    }),

  insureeIsDriver: (value) =>
    logEvent('marked_insurance_is_driver', {
      event_category: 'Inputs',
      event_label: `marked_insurance_is_driver_${value ? 'true' : 'false'}`,
      value: value ? 1 : 0,
    }),

  hasFinancialEntity: (value) =>
    logEvent('marked_has_financial_entity', {
      event_category: 'Inputs',
      event_label: `marked_has_financial_entity_${value ? 'true' : 'false'}`,
      value_name: value ? 'true' : 'false',
      value: value ? 1 : 0,
    }),

  submitPersonalDataForm: () =>
    logEvent('submit_personal_data_form', {
      event_category: 'Button',
      event_label: 'submit_personal_data_form',
      value: 1,
    }),

  submitPaymentForm: () =>
    logEvent('submit_payment_form', {
      event_category: 'Button',
      event_label: 'submit_payment_form',
      value: 1,
    }),
};
